export default "__VITE_ASSET__CUVgO_gV__"